import * as actionTypes from "../actions";
import { addItemInListOfItems, deleteItemByIdInListOfItems, updateItemInListOfItems } from "../../helpers";


const initialState = {
    orderShiftModalVisible: false,
    orderShiftSummaryModalVisible: false,
    orderProductModalVisible: false,
    orderModalVisible: false,
    manualOrderModalVisible: false,

    orderSettings: {
        id: null,
        shop_active: false,
        minimum_order_amount: "5.00",
        min_duration: "1 00:00:00",
        max_duration: "14 00:00:00",
        delivery_enabled: false,
        delivery_max_distance: 15,
        delivery_price: "5.00",
        delivery_free_enabled: false,
        delivery_free_above: "20.00"
    },
    getOrderSettingsLoading: false,
    getOrderSettingsError: null,

    orderShifts: [],
    getOrderShiftsLoading: false,
    getOrderShiftsError: null,
    addOrderShiftLoading: false,
    addOrderShiftError: null,
    deleteOrderShiftLoading: false,
    deleteOrderShiftError: null,
    updateOrderShiftLoading: false,
    updateOrderShiftError: null,

    orderProducts: [],
    getOrderProductsLoading: false,
    getOrderProductsError: null,
    addOrderProductLoading: false,
    addOrderProductError: null,
    deleteOrderProductLoading: false,
    deleteOrderProductError: null,
    updateOrderProductLoading: false,
    updateOrderProductError: null,

    orders: [],
    pastOrders: [],
    orderPageMeta: {
        count: null,
        current: null,
        next: null,
        previous: null,
        page_size: null,
        total_pages: null,
    },
    getOrdersLoading: false,
    getOrdersError: null,
    updateOrderLoading: false,
    updateOrderError: null,

    markAsReadOrderLoading: false,
    markAsReadOrderError: null,
};


const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_ORDER_MODAL:
            return {
                ...state,
                orderModalVisible: !state.orderModalVisible
            };

        case actionTypes.TOGGLE_MANUAL_ORDER_MODAL:
            return {
                ...state,
                manualOrderModalVisible: !state.manualOrderModalVisible
            };

        case actionTypes.TOGGLE_ORDER_SHIFT_MODAL:
            return {
                ...state,
                orderShiftModalVisible: !state.orderShiftModalVisible
            };

        case actionTypes.TOGGLE_ORDER_PRODUCT_MODAL:
            return {
                ...state,
                orderProductModalVisible: !state.orderProductModalVisible
            };

        case actionTypes.TOGGLE_ORDER_SHIFT_SUMMARY_MODAL:
            return {
                ...state,
                orderShiftSummaryModalVisible: !state.orderShiftSummaryModalVisible
            };

        // GET ORDER SETTINGS
        case actionTypes.GET_ORDER_SETTINGS_REQUEST:
            return {
                ...state,
                getOrderSettingsLoading: action.loading
            };
        case actionTypes.GET_ORDER_SETTINGS_SUCCESS:
            return {
                ...state,
                getOrderSettingsLoading: action.loading,
                getOrderSettingsError: action.error,
                orderSettings: action.orderSettings
            };
        case actionTypes.GET_ORDER_SETTINGS_ERROR:
            return {
                ...state,
                getOrderSettingsLoading: action.loading,
                getOrderSettingsError: action.error
            };

        // UPDATE ORDER SETTINGS
        case actionTypes.UPDATE_ORDER_SETTINGS_REQUEST:
            return {
                ...state,
                updateOrderSettingsLoading: action.loading
            };
        case actionTypes.UPDATE_ORDER_SETTINGS_SUCCESS:
            return {
                ...state,
                updateOrderSettingsLoading: action.loading,
                updateOrderSettingsError: action.error,
                orderSettings: action.orderSettings
            };
        case actionTypes.UPDATE_ORDER_SETTINGS_ERROR:
            return {
                ...state,
                updateOrderSettingsLoading: action.loading,
                updateOrderSettingsError: action.error
            };

        // GET ORDER_SHIFTS
        case actionTypes.GET_ORDER_SHIFTS_REQUEST:
            return {
                ...state,
                getOrderShiftsLoading: action.loading
            };
        case actionTypes.GET_ORDER_SHIFTS_SUCCESS:
            return {
                ...state,
                getOrderShiftsLoading: action.loading,
                getOrderShiftsError: action.error,
                orderShifts: action.orderShifts
            };
        case actionTypes.GET_ORDER_SHIFTS_ERROR:
            return {
                ...state,
                getOrderShiftsLoading: action.loading,
                getOrderShiftsError: action.error
            };

        // ADD ORDER_SHIFT
        case actionTypes.ADD_ORDER_SHIFT_REQUEST:
            return {
                ...state,
                addOrderShiftLoading: action.loading
            };
        case actionTypes.ADD_ORDER_SHIFT_SUCCESS:
            return {
                ...state,
                addOrderShiftLoading: action.loading,
                addOrderShiftError: action.error,
                orderShifts: addItemInListOfItems(state.orderShifts, action.orderShift)
            };
        case actionTypes.ADD_ORDER_SHIFT_ERROR:
            return {
                ...state,
                addOrderShiftLoading: action.loading,
                addOrderShiftError: action.error
            };

        // DELETE ORDER_SHIFT
        case actionTypes.DELETE_ORDER_SHIFT_REQUEST:
            return {
                ...state,
                deleteOrderShiftLoading: action.loading
            };
        case actionTypes.DELETE_ORDER_SHIFT_SUCCESS:
            return {
                ...state,
                deleteOrderShiftLoading: action.loading,
                deleteOrderShiftError: action.error,
                orderShifts: deleteItemByIdInListOfItems(state.orderShifts, action.orderShiftId)
            };
        case actionTypes.DELETE_ORDER_SHIFT_ERROR:
            return {
                ...state,
                deleteOrderShiftLoading: action.loading,
                deleteOrderShiftError: action.error
            };

        // UPDATE ORDER_SHIFT
        case actionTypes.UPDATE_ORDER_SHIFT_REQUEST:
            return {
                ...state,
                updateOrderShiftLoading: action.loading
            };
        case actionTypes.UPDATE_ORDER_SHIFT_SUCCESS:
            return {
                ...state,
                updateOrderShiftLoading: action.loading,
                updateOrderShiftError: action.error,
                orderShifts: updateItemInListOfItems(state.orderShifts, action.orderShift)
            };
        case actionTypes.UPDATE_ORDER_SHIFT_ERROR:
            return {
                ...state,
                updateOrderShiftLoading: action.loading,
                updateOrderShiftError: action.error
            };

        // GET ORDER_PRODUCTS
        case actionTypes.GET_ORDER_PRODUCTS_REQUEST:
            return {
                ...state,
                getOrderProductsLoading: action.loading
            };
        case actionTypes.GET_ORDER_PRODUCTS_SUCCESS:
            return {
                ...state,
                getOrderProductsLoading: action.loading,
                getOrderProductsError: action.error,
                orderProducts: action.orderProducts
            };
        case actionTypes.GET_ORDER_PRODUCTS_ERROR:
            return {
                ...state,
                getOrderProductsLoading: action.loading,
                getOrderProductsError: action.error
            };

        // ADD ORDER_PRODUCT
        case actionTypes.ADD_ORDER_PRODUCT_REQUEST:
            return {
                ...state,
                addOrderProductLoading: action.loading
            };
        case actionTypes.ADD_ORDER_PRODUCT_SUCCESS:
            return {
                ...state,
                addOrderProductLoading: action.loading,
                addOrderProductError: action.error,
                orderProducts: addItemInListOfItems(state.orderProducts, action.orderProduct)
            };
        case actionTypes.ADD_ORDER_PRODUCT_ERROR:
            return {
                ...state,
                addOrderProductLoading: action.loading,
                addOrderProductError: action.error
            };

        // DELETE ORDER_PRODUCT
        case actionTypes.DELETE_ORDER_PRODUCT_REQUEST:
            return {
                ...state,
                deleteOrderProductLoading: action.loading
            };
        case actionTypes.DELETE_ORDER_PRODUCT_SUCCESS:
            return {
                ...state,
                deleteOrderProductLoading: action.loading,
                deleteOrderProductError: action.error,
                orderProducts: deleteItemByIdInListOfItems(state.orderProducts, action.orderProductId)
            };
        case actionTypes.DELETE_ORDER_PRODUCT_ERROR:
            return {
                ...state,
                deleteOrderProductLoading: action.loading,
                deleteOrderProductError: action.error
            };

        // UPDATE ORDER_PRODUCT
        case actionTypes.UPDATE_ORDER_PRODUCT_REQUEST:
            return {
                ...state,
                updateOrderProductLoading: action.loading
            };
        case actionTypes.UPDATE_ORDER_PRODUCT_SUCCESS:
            return {
                ...state,
                updateOrderProductLoading: action.loading,
                updateOrderProductError: action.error,
                orderProducts: updateItemInListOfItems(state.orderProducts, action.orderProduct)
            };
        case actionTypes.UPDATE_ORDER_PRODUCT_ERROR:
            return {
                ...state,
                updateOrderProductLoading: action.loading,
                updateOrderProductError: action.error
            };

        // GET ORDERS
        case actionTypes.GET_ORDERS_REQUEST:
            return {
                ...state,
                getOrdersLoading: action.loading
            };
        case actionTypes.GET_ORDERS_SUCCESS:
            return {
                ...state,
                getOrdersLoading: action.loading,
                getOrdersError: action.error,
                orders: action.orders,
                orderPageMeta: action.orderPageMeta
            };
        case actionTypes.GET_ORDERS_ERROR:
            return {
                ...state,
                getOrdersLoading: action.loading,
                getOrdersError: action.error
            };

        // GET PAST ORDERS
        case actionTypes.GET_PAST_ORDERS_SUCCESS:
            return {
                ...state,
                getOrdersLoading: action.loading,
                getOrdersError: action.error,
                pastOrders: action.pastOrders,
                orderPageMeta: action.orderPageMeta
            };

        // GET NEW ORDERS
        case actionTypes.GET_NEW_ORDERS_REQUEST:
            return {
                ...state,
                getOrdersLoading: action.loading
            };
        case actionTypes.GET_NEW_ORDERS_SUCCESS:
            return {
                ...state,
                getOrdersLoading: action.loading,
                getOrdersError: action.error,
                orders: action.orders
            };
        case actionTypes.GET_NEW_ORDERS_ERROR:
            return {
                ...state,
                getOrdersLoading: action.loading,
                getOrdersError: action.error
            };

        // UPDATE ORDER
        case actionTypes.UPDATE_ORDER_REQUEST:
            return {
                ...state,
                updateOrderLoading: action.loading
            };
        case actionTypes.UPDATE_ORDER_SUCCESS:
            return {
                ...state,
                updateOrderLoading: action.loading,
                updateOrderError: action.error,
                orders: updateItemInListOfItems(state.orders, action.order),
                pastOrders: updateItemInListOfItems(state.pastOrders, action.order),
            };
        case actionTypes.UPDATE_ORDER_ERROR:
            return {
                ...state,
                updateOrderLoading: action.loading,
                updateOrderError: action.error
            };

        // MARK AS READ ORDER
        case actionTypes.MARK_AS_READ_ORDER_REQUEST:
            return {
                ...state,
                markAsReadOrderLoading: action.loading
            };
        case actionTypes.MARK_AS_READ_ORDER_SUCCESS:
            return {
                ...state,
                markAsReadOrderLoading: action.loading,
                markAsReadOrderError: action.error,
                orders: updateItemInListOfItems(state.orders, action.order),
                pastOrders: updateItemInListOfItems(state.pastOrders, action.order),
            };
        case actionTypes.MARK_AS_READ_ORDER_ERROR:
            return {
                ...state,
                markAsReadOrderLoading: action.loading,
                markAsReadOrderError: action.error
            };

        // MARK AS READ ALL ORDERS
        case actionTypes.MARK_AS_READ_ALL_ORDERS_REQUEST:
            return { ...state, markAsReadAllOrdersLoading: true, markAsReadAllOrdersError: null };

        case actionTypes.MARK_AS_READ_ALL_ORDERS_SUCCESS:
            return {
                ...state,
                markAsReadAllOrdersLoading: false,
                markAsReadAllOrdersError: null,
                orders: state.orders.map(o => ({ ...o, read: true })),
                lastOrdersBulkResult: action.result,
            };

        case actionTypes.MARK_AS_READ_ALL_ORDERS_ERROR:
            return { ...state, markAsReadAllOrdersLoading: false, markAsReadAllOrdersError: action.error };



        default:
            return state;
    }
};

export default ordersReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/orders.js